/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Lpdealoverviewcontent_Keymetrics5Inputs */

const en_coinvestments_lpdealoverviewcontent_keymetrics5 = /** @type {(inputs: Coinvestments_Lpdealoverviewcontent_Keymetrics5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Key Metrics`)
};

/**
* | output |
* | --- |
* | "Key Metrics" |
*
* @param {Coinvestments_Lpdealoverviewcontent_Keymetrics5Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_lpdealoverviewcontent_keymetrics5 = /** @type {((inputs?: Coinvestments_Lpdealoverviewcontent_Keymetrics5Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Lpdealoverviewcontent_Keymetrics5Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_lpdealoverviewcontent_keymetrics5(inputs)
});
export { coinvestments_lpdealoverviewcontent_keymetrics5 as "coInvestments_lpDealOverviewContent_keyMetrics" }